import $ from 'jquery';
import { getParam } from './getParam';

export const updateCart = () => {
  const uid = getParam('uid');

  const cart = JSON.parse(localStorage.getItem(`${uid}-cart`)) || [];
  console.log(cart.length);
  const totalQuantity = cart.reduce((total, item) => total + item.quantity, 0);
  $('.cart_count').text(totalQuantity || 0);

  if (cart.length === 0) {
    $('.cart-items').hide();
    $('.cart-null').show();
  } else {
    $('.cart-items').show();
    $('.cart-null').hide();
  }

  const gdprDismissed =
    uid &&
    document.cookie.split(';').some((item) => item.trim().startsWith(`hideGdpr-${uid}=`));

  if (gdprDismissed) {
    $('#gdpr').remove();
  } else {
    $('#gdpr').remove();
    const cookieBlock = `
    <section id="gdpr">
  <div class="gdpr__box">
    <div class="gdpr__container">
      <div class="gdpr__text"> We use cookies (and other similar technologies) for many purposes, including to improve
        your experience on our site and for ads and analytics. Click "Accept all" to accept these uses. Read more in our
        <a data-page="privacy-policy" class="get_page">Cookie Policy</a>.
      </div>
      <div class="gdpr__buttons"><span class="gdpr__close" style=""> Reject all </span> <span
        class="gdpr__close gdpr__dark"> Accept all </span></div>
    </div>
  </div>
</section>`;
    $('body').append(cookieBlock);
  }

  $(document).off('click.hideGdpr', '.gdpr__close').on('click.hideGdpr', '.gdpr__close', function (e) {
    e.preventDefault();
    $(e.currentTarget).closest('#gdpr').remove();
    const d = new Date();
    d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
    document.cookie = `hideGdpr-${uid}=true; expires=${d.toUTCString()}; path=/`;
  });
};
